import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import Tab4 from './Tab4';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json';
import SweetAlert from "sweetalert2";
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Box, Grid, Typography } from '@mui/material';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import formatDate from '../../../../../Functions/Traitement/fomatDate';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import HelpInfos from '../../../../HelpInfo';
import HelpData from "../../../../../Data/Help.json";
import Help from '../../../../../Types/Help';
import { DemandeIjaraDto } from '../../../../../Models/DemandeIjarahDto';
import DataTypeTable from '../../../../../Types/DataTypeTable';
import { useAgence } from '../../../../../AgenceContext';
import { PrintTabamountDemandeIjara } from '../../../../../utilitaires/printTabamortDemandeIjara';

interface SelectData {
  value: string;
  label: string;
}

const DemandeIjarah = () => {
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  const authHeader = useAuthHeader();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [ajoutActve, setAjoutActif] = useState(false);
  const [modifActve, setModifActve] = useState(true);
  const [enregActve, setEnregActve] = useState(true);
  const [supActive, setSupActive] = useState(true);
  const [impActive, setImpActive] = useState(true);
  const [actuActive, setActActive] = useState(true);
  const [annulActive, setAnnulActive] = useState(true);
  const [consulActive, setConsulActive] = useState(false);
  const [document,setDocument] = useState([]);
  const [sbmit, setSbmit] = useState('');
  const [DataGarantie, SetDataGarantie] = useState<SelectData[]>([]);
  const Branch = useAgence();

  const [garantiesTableau, setGarantiesTableau] = useState<DataTypeTable[]>([]);

  useEffect(() => { forceUpdate({}); }, []);

  function initialiazeButton() {
    setAjoutActif(false);
    setModifActve(true);
    setEnregActve(true);
    setSupActive(true);
    setImpActive(true);
    setActActive(true);
    setAnnulActive(true);
    setConsulActive(false);
  }

  function enableEditMode() {
    setAjoutActif(true);
    setEnregActve(false);
    setAnnulActive(false);
    setConsulActive(true);
    setModifActve(true);
    setImpActive(true);
    setSupActive(true);
    setActActive(true);
    // ⚠️ Ne pas toucher à sbmit ici
  }

  const SetStart = () => {
    SetDataGarantie([]);
    setGarantiesTableau([]);
    localStorage.removeItem(Data.LocalVariable.garantie);
    setSbmit('add');
    setAjoutActif(true);
    setEnregActve(false);
    setAnnulActive(false);
    setConsulActive(true);
    form.resetFields();
  };

  const SetEndStart = () => { SetStartForm(true); SeStartSearchG(false); };

  function handleAnulle() {
    let coduti = form.getFieldValue('CODUTI');
    form.resetFields();
    localStorage.clear();
    form.setFieldValue('CODUTI', coduti);
    initialiazeButton();
    SetDataGarantie([]);
    setGarantiesTableau([]);
  }

  function cunsultButton() { setAnnulActive(false); setModifActve(false); setImpActive(false); }
  function modifButton() { setSbmit('update'); setModifActve(true); setAjoutActif(true); setEnregActve(false); setConsulActive(true); setImpActive(true); }

  function LoadGarantie() {
    SetDataGarantie([]);
    let dataGarantie: SelectData[] = [];
    try {
      let numcli = form.getFieldValue('NUMCLI');
      numcli += Data.LocalVariable.separator + 'CL';
      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetGarantie,
        headers: {
          'Content-Type': 'application/json',
          Authorization: authHeader(),
          CypherSearch: Crypter.encrypt(JSON.stringify(numcli)),
        },
      };
      axios(config)
        .then((response) => {
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode == 200) {
              let datas = res.Result.Table;
              let filtered = datas.filter((item: any) => item.CdEtat === '02');
              if (filtered.length === 0) {
                localStorage.setItem('garanties_client', '');
              } else {
                filtered.map((data: any) => {
                  dataGarantie.push({
                    value: data.codgar + '|' + data.dispo,
                    label: data.codgar + ' -> ' + formatNumber(parseFloat(data.VALGARANTI)) + ' XAF( disponible : ' + formatNumber(parseFloat(data.dispo + '')) + ' XAF)',
                  });
                });
                SetDataGarantie(dataGarantie);
                localStorage.setItem('garanties_client', Crypter.encrypt(JSON.stringify(filtered)));
              }
            }
          }
        })
        .catch((error) => {
          SweetAlert.fire({ title: 'Error', text: error, icon: 'error' });
        });
    } catch (error) {
      SweetAlert.fire({
        title: "Veillez sélectionnez le client donc vous voulez charger les garantie",
        icon: 'warning',
      });
      localStorage.setItem('garanties_client', '');
    }
  }

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (<span id="Tab"><UserOutlined />Demande</span>),
      children: (<Tab1 
        form={form} 
        disabled={!ajoutActve}
        LoadGarantie={LoadGarantie} 
        onEnableEdit={enableEditMode}
        isLoading={loading}
      />),
    },
    {
      key: '2',
      label: (<span id="Tab"><ContactsOutlined />Garanties</span>),
      children: (
        <Tab2
          form={form}
          Datagarantie={DataGarantie}
          garantiesTableau={garantiesTableau}
          setGarantiesTableau={setGarantiesTableau}
        />
      ),
    },
    {
      key: '3',
      label: (<span id="Tab"><UsergroupAddOutlined />Frais de service</span>),
      children: <Tab3 form={form} />,
    },
    {
      key: '4',
      label: (
        <span id='Tab'>
          <UserOutlined /> Documents
        </span>
      ),
      children: <Tab4 form={form} document={document} />,
    },

  ];

  const onFinish = (val: any) => {
    const values = form.getFieldsValue(true);
    
    // Construire la liste des garanties à partir du tableau
    let Garanties = garantiesTableau
  .filter((data: any) => (data.CodeGarantie || data.codgar)) // ignore les entrées vides
  .map((data: any) => ({
    CodeGarantie: String(data.CodeGarantie || data.codgar).trim(),
    MontantCouvert: data.valCouvert || 0,
  }));

    // Calcul du total des garanties couvertes pour CPTGARAN
    const totalGaranties = garantiesTableau.reduce(
      (sum, g) => sum + Number(g.valCouvert || 0),
      0
    );

    // Construire le DTO avec tous les champs
    const DemandeIjarah: DemandeIjaraDto = {
      NumeroDemande: values.NumeroDemande,
      CodeIjara: values.CodeIjara,
      TypeIjaraDemande: values.TypeIjaraDemande || 'IMB',
      NUMCLI: values.NUMCLI,
      NOMCLI: values.lib_NUMCLI || values.NOMCLI,
      CPTREMBOURSEMENT: values.CPTREMBOURSEMENT,
      CPTREGLEMENT: values.CPTREGLEMENT,   
      MOTIFDEM: values.MOTIFDEM,
      CodeActif: values.CodeActif,
      NUMCLIFOUR: values.NUMCLIFOUR,
      Quantite: Number(values.Quantite) || 1,
      DureeContrat: Number(values.DureeContrat) || 0,
      DureeAmortBien: Number(values.DureeAmortBien) || 0,
      DureeDifferee: Number(values.DureeDifferee) || 0,
      NombreEch: Number(values.NombreEch) || 0,
      NombreEchAmort: Number(values.NombreEchAmort) || 0,
      MontantCharge: Number(values.MontantCharge) || 0,
      MontantPromesse: Number(values.MontantPromesse) || 0,
      MontantFrais: Number(values.MontantFrais) || 0,
      Periodicite: values.Periodicite,
      PeriodiciteAmort: values.PeriodiciteAmort,
      DatePremEch: values.DatePremEch ? new Date(values.DatePremEch).toISOString().split('T')[0] : '',
      DatePremEchAmort: values.DatePremEchAmort ? new Date(values.DatePremEchAmort).toISOString().split('T')[0] : '',
      CODGEA: values.CODGEA,
      CODOBJECT: values.CODOBJECT,
      CODACTIVE: values.CODACTIVE,
      Frais:values.Frais,
      CODAGE: user.codage,
      MONTEPARG: Number(values.MONTEPARG) || 0,
      CoutAcquisitionDemande: Number(values.CoutAcquisitionDemande) || 0,
      MargeLocativeDemande: Number(values.MargeLocativeDemande) || 0,
      ValeurResiduelleDemande: Number(values.ValeurResiduelleDemande) || 0,
      CommentaireDemande: values.CommentaireDemande,
      UtilDemande: user.coduti,
      CoutAcquisitionProp: Number(values.CoutAcquisitionProp) || 0,
      MargeLocativeProp: Number(values.MargeLocativeProp) || 0,
      ValeurResiduelleProp: Number(values.ValeurResiduelleProp) || 0,
      CommentairePropose: values.CommentairePropose,
      UtilPropose: values.UtilPropose,
      CoutAcquisitionValide: Number(values.CoutAcquisitionValide) || 0,
      MargeLocativeValide: Number(values.MargeLocativeValide) || 0,
      ValeurResiduelleValide: Number(values.ValeurResiduelleValide) || 0,
      CommentaireValide: values.CommentaireValide,
      UtilVal: values.UtilVal,
      Observation: values.Observation,
      CodeUti: user.coduti,
      Garanties: Garanties,
      Documents: [],
    };

    const isGarantieOblig = ['true','1','yes','oui', true].some(v =>
      String(values.IsGarantieObligatoir ?? '').toLowerCase() === String(v)
    );
    if (isGarantieOblig) {
      SweetAlert.fire({
        title: "Vous devez d'abord sélectionner les garanties de prêt avant d'enregistrer",
        icon: 'warning',
      });
      return;
    }

    if (sbmit === 'add') {
      SweetAlert.fire({
        title: `Voulez-vous enregistrer la demande de financement Ijarah ${DemandeIjarah.CodeIjara}\n du client : ${DemandeIjarah.NUMCLI} Montant ${DemandeIjarah.CoutAcquisitionDemande}`,
        showCancelButton: true,
        color: 'green',
        confirmButtonText: 'Yes',
        confirmButtonColor: 'green',
        cancelButtonColor: 'darkred',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        icon: 'question',
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true);
          let data = Crypter.encrypt(JSON.stringify(DemandeIjarah));
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.DemandeIjarah,
            headers: {
              Authorization: authHeader(),
              'Content-Type': 'application/json',
            },
            data: data,
          };
          axios
            .request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                if (res.StatutCode == 200) {
                  initialiazeButton();
                  form.resetFields();
                  setGarantiesTableau([]);
                  setImpActive(false);
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'success' });
                } else {
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' });
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error);
              SweetAlert.fire({ title: 'Erreur', text: String(error), icon: 'error' });
            });
        }
      });
    }

    if (sbmit === "Apercu") {
          setLoading(true);
          console.log("reponse",DemandeIjarah);
          DemandeIjarah.CodeIjara = DemandeIjarah.CodeIjara + '-' + '' + values.lib_CodeIjara;
          PrintTabamountDemandeIjara(
            user.coduti ?? '',
            user.codage ?? '',
            Branch.agence?.LIBELLE ?? '',
            Branch.agence?.BANQUE ?? '',
            Branch.agence?.TELEPH ?? '',
            Branch.agence?.NUMREG ?? '',
            Branch.agence?.LICENCE ?? '',
            Branch.agence?.NUMREG ?? '',
            Branch.agence?.BPOSTE ?? '',
            Branch.agence?.VILLE ?? '',
            user.nomuti ?? '',
            // values.lib_Periodicite,
            DemandeIjarah.NumeroDemande,
         
          );
          setLoading(false);
          setSbmit("add");
        }

    if (sbmit === 'update') {
      SweetAlert.fire({
        title: 'Voulez-vous modifier la demande de financement ' + values.NumeroDemande + ' ?',
        showCancelButton: true,
        color: 'green',
        confirmButtonText: 'Yes',
        confirmButtonColor: 'green',
        cancelButtonColor: 'darkred',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        icon: 'question',
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true);
          let data = Crypter.encrypt(JSON.stringify(DemandeIjarah));
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.UpdateFindIjarah,
            headers: {
              Authorization: authHeader(),
              'Content-Type': 'application/json',
            },
            data: data,
          };
          axios
            .request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                if (res.StatutCode == 200) {
                  initialiazeButton();
                  form.resetFields();
                  setGarantiesTableau([]);
                  setImpActive(false);
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'success' });
                } else {
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' });
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error);
              SweetAlert.fire({ title: 'Erreur', text: String(error), icon: 'error' });
            });
        }
      });
    }
  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];
    errorInfo.errorFields.map((error: any) => {
      errors.push(error.name + '');
    });
    SweetAlert.fire({
      title: 'Veuillez remplir tous les champs obligatoires',
      text: errors.toString().replaceAll(',', ' - '),
      icon: 'warning',
      confirmButtonText: 'OK',
    });
  };

  function consult() {
    let data = Crypter.encrypt(form.getFieldValue('NumeroDemande'));
    let numdemande = form.getFieldValue('NumeroDemande');
    let dataction = Crypter.encrypt('READ_DEMANDE');
    if (data.length != 0) {
      form.setFieldValue('garantie', '');
      form.setFieldValue('avaliste', '');
      initialiazeButton();
      setLoading(true);
      form.resetFields();
      form.setFieldValue('NumeroDemande', numdemande);
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.ReadFinancementIjarah,
        headers: {
          CypherNumeroDemandeIjara: data,
          CypherAction: dataction,
          Authorization: authHeader(),
          'Content-Type': 'application/json',
        },
      };
      axios
        .request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            console.log("reponse_demande",res);
            if (res.StatutCode == 200) {
              const row = res.Result.Table1[0];
              form.setFieldValue('DatePremEch', ReformatDate(res.Result.Table1[0].DatePremEch));
              form.setFieldsValue({
                NumeroDemande: row.NumeroDemande,
                CodeIjara: row.CodeIjara,
                TypeIjaraDemande: row.TypeIjaraDemande,
                NUMCLI: row.NUMCLI,
                NOMCLI: row.NOMCLI,
                lib_NUMCLI: row.NOMCLI,
                CPTREMBOURSEMENT: row.CPTREMBOURSEMENT,
                CPTREGLEMENT: row.CPTREGLEMENT,
                // CPTGARAN n'est pas utilisé car on le calcule
                MOTIFDEM: row.MOTIFDEM,
                CodeActif: row.CodeActif,
                Quantite: row.Quantite,
                DureeContrat: row.DureeContrat,
                DureeAmortBien: row.DureeAmortBien,
                NombreEch: row.NombreEch,
                Periodicite: row.Periodicite,
                PeriodiciteAmort: row.PeriodiciteAmort,
                ...row,
              });

              // Garanties
              const garantiesRetournees: DataTypeTable[] = [];
if (res.Result.Table2) {
  res.Result.Table2.map((data: any) => {
    garantiesRetournees.push({
      ...data,
      CodeGarantie: data.CodeGarantie || data.codgar, // ← unifier
      valCouvert: data.MontantCouvert,
    });
  });
}
 // 🔥 Récupération des documents (Table4)
              let documents = [];
              if (res.Result.Table4) {
                documents = res.Result.Table4.map((doc: any) => ({
                  ...doc,
                  key: doc.TypeCodeDoc || doc.IdDocument,
                }));
              }
              setDocument(documents);

              setGarantiesTableau(garantiesRetournees);
              localStorage.setItem(Data.LocalVariable.garantie, JSON.stringify(garantiesRetournees));
              consultTypeIjarah();
              initialiazeButton();
              cunsultButton();
            } else {
              localStorage.removeItem(Data.LocalVariable.reset);
              SweetAlert.fire({ title: res.Message, icon: 'warning' });
            }
          }
          setLoading(false);
        })
        .catch((error) => {
          localStorage.removeItem(Data.LocalVariable.reset);
          setLoading(false);
          console.log(error);
          SweetAlert.fire({ title: 'Erreur', text: String(error), icon: 'error' });
        });
    }
  }

  function modif() {
    modifButton();
  }

  function consultTypeIjarah() {
    if (form.getFieldValue('CodeIjara') == null) {
      SweetAlert.fire({ title: 'Svp renseigner le Code du type de Ijarah ', icon: 'warning' });
    } else {
      let data = Crypter.encrypt(form.getFieldValue('CodeIjara'));
      console.log(data);
      if (data.length != 0) {
        setLoading(true);
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.ReadParamsIjarah,
          headers: {
            CypherCodeIjara: data,
            Authorization: authHeader(),
            'Content-Type': 'application/json',
          },
        };
        axios
          .request(config)
          .then((response) => {
            setLoading(false);
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;
              console.log("repoonse", res);
              if (res.StatutCode == 200) {
                const params = res.Result.Table1?.[0] || {};
                const isGarantieOblig = ['true','1','yes','oui', true].some(v =>
                  String(params?.IsGarantieObligatoir ?? '').toLowerCase() === String(v)
                );
                form.setFieldValue('IsGarantieObligatoir', isGarantieOblig);
                const frais = params.MontantFrais || 0;
                form.setFieldValue('MontantFrais', frais);
                form.setFieldValue('CodeFrais', res.Result.Table4?.map((x: any) => x.CODOPE) || []);
              } else {
                SweetAlert.fire({ title: 'Warning', text: res.Message, icon: 'warning' });
              }
            }
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            console.log(error);
            SweetAlert.fire({ title: 'Error', text: String(error), icon: 'error' });
          });
      }
    }
  }

  return (
    <div className="tab">
      <Typography align="center" className="formTitle">
        <b>{window.location.pathname}</b>
      </Typography>
      <Spin spinning={loading} size="large" style={{ color: 'green' }}>
        <Form
          disabled={!ajoutActve}
          autoComplete="off"
          preserve
          labelAlign="left"
          form={form}
          name="dynamic_form_complex"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ minWidth: 'auto', maxWidth: 'auto' }}
        >
          <div className="bG">
            <legend>
              <Typography color={'darkgreen'}>Actions</Typography>
            </legend>
            <Form.Item shouldUpdate className="bouttong">
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={consulActive}
                  onClick={consult}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Consulter
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={ajoutActve}
                  onClick={SetStart}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Ajouter
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={modifActve}
                  onClick={modif}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Modifier
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={enregActve}
                  type="ghost"
                  htmlType="submit"
                  block
                >
                  Enregistrer
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  onClick={SetEndStart}
                  disabled={supActive}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Supprimer
                </Button>
                <Button
                  size="large"
                  onClick={() => {
                    setSbmit('Apercu');
                  }}
                  className="bt_add"
                  disabled={impActive}
                  type="ghost"
                  htmlType="submit"
                  block
                >
                  Aperçu
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={actuActive}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Actualiser
                </Button>
                <Button
                  size="large"
                  disabled={annulActive}
                  onClick={handleAnulle}
                  className="bt_add"
                  type="ghost"
                  htmlType="reset"
                  block
                >
                  Annuler
                </Button>
              </Space>
            </Form.Item>
            <HelpInfos helpInfo={HelpData.Pret.DemandeDePret as Help} />
          </div>
          <div className="clientP">
            <div>
              <Tabs size="large" type="card" defaultActiveKey="1" items={items} />
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default DemandeIjarah;